// extracted by mini-css-extract-plugin
module.exports = {"container":"Wheel_container__SAAZ3","circleContainer":"Wheel_circleContainer__3rvCp","pic":"Wheel_pic__1csVM","segments":"Wheel_segments__1ypJZ","segment":"Wheel_segment__b4WBC"};